import { useEffect, useState, type ReactNode } from 'react';
import { frameStats, onAnimationFrame, type FrameStats } from '@casa/tiles';

// Frame times, to judge smoothness by numbers as well as by eye. Shown while the address has
// `#frames` (set it from DevTools: `location.hash = 'frames'`). While shown it keeps the loop
// running, so the numbers cover idle frames too.

const isRequested = () : boolean => location.hash.includes('frames');

export function FrameOverlay() : ReactNode {
    const [shown, setShown] = useState(isRequested);
    const [stats, setStats] = useState<FrameStats | null>(null);

    useEffect(() => {
        const update = () : void => setShown(isRequested());
        window.addEventListener('hashchange', update);

        return () => window.removeEventListener('hashchange', update);
    }, []);

    useEffect(() => {
        if (!shown) {
            return;
        }

        const stop = onAnimationFrame(() => {});
        const timer = setInterval(() => setStats(frameStats()), 500);

        return () => {
            stop();
            clearInterval(timer);
        };
    }, [shown]);

    if (!shown || !stats) {
        return null;
    }

    const ms = (value: number) : string => value.toFixed(1);

    return (
        <pre
            id="frame-overlay"
            style={{
                position: 'fixed',
                left: 8,
                bottom: 8,
                margin: 0,
                padding: '4px 8px',
                background: 'rgba(0, 0, 0, 0.75)',
                color: '#00ff00',
                font: '12px monospace',
                pointerEvents: 'none',
                zIndex: 10,
            }}
        >
            {`${stats.framesPerSecond.toFixed(1)} fps  interval median ${ms(stats.medianInterval)}  p95 ${ms(stats.p95Interval)}  max ${ms(stats.maxInterval)} ms\n`}
            {`work mean ${ms(stats.meanWork)}  max ${ms(stats.maxWork)} ms  (${stats.frames} frames / 2 s)`}
        </pre>
    );
}
